import { render } from "./disclaimer.vue?vue&type=template&id=d9d30528&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=d9d30528&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9d30528"

export default script